<template>
  <div id="synonymFormatSelector">
    <h4 class="var-header">
      {{ $t("radio-btn-group.formatting") }}
    </h4>
    <div class="format-content custom-scrollbar-grey">
      <div v-if="formatType" class="preview-variable-cell">
        <FormatRadioButtons
          :formatList="variableFormats"
          :examples="examples"
          @format-changed="onFormatChanged"
          @on-format-input="onFormatInput"
          :_selectedFormat="selectedFormat"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormatRadioButtons from "@/components/FormatRadioButtons";
export default {
  data() {
    return {
      examples: [],
      selectedFormat: "",
    };
  },
  props: {
    synonym: {
      type: Object,
      required: true,
    },
    formatting: String,
    formatType: {
      type: String,
    },
    formatsForMethods: Boolean,
    updatedFormat: String,
  },
  computed: {
    currentFormat() {
      return this.variableFormats.find((f) => f.name === this.selectedFormat);
    },
    variableFormats() {
      return [
        { description: "No formatting", inputValues: {}, inputs: null, name: "" },
        ...this.$store.state.variableFormats[this.formatType],
      ];
    },
  },
  methods: {
    onFormatInput(format) {
      const formatValues = Object.values(this.variableFormats.find((f) => f.name == format).inputValues).join(";");
      const fullFormat = format + (!formatValues.length ? "" : ";" + formatValues);
      this.$emit("format-changed", fullFormat);
      this.loadFormatExamples()
    },
    onFormatChanged(format) {
      this.$emit("format-changed", format);
    },
    exampleResult(example) {
      // console.log(example)
      this.$emit("example-result", example);
    },
    loadFormatExamples() {
      this.$store
        .dispatch("getSynonymFormatExamples", {
          synonym: this.synonym,
          formats: this.variableFormats.map((f) => {
            let format = f.name;
            if (f.inputValues) {
              if (f.inputValues[0] !== undefined && f.inputValues[0] !== "") format += ";" + f.inputValues[0];
              if (f.inputValues[1] !== undefined && f.inputValues[1] !== "") format += ";" + f.inputValues[1];
            }
            return format;
          }),
          all: false,
        })
        .then((res) => {
          this.examples = res;
        });
    },
  },
  mounted() {
    this.loadFormatExamples();
    this.variableFormats.forEach((f) => {
      if (!f.inputValues) this.$set(f, "inputValues", {});
    });
  },
  watch: {
    synonym: {
      immediate: true,
      handler() {
        let format = this.updatedFormat || "";
        if (format.indexOf(";") > -1) {
          this.selectedFormat = format.substr(0, format.indexOf(";"));
          format
            .replace(this.selectedFormat + ";", "")
            .split(";")
            .forEach((input, index) => this.$set(this.currentFormat.inputValues, index, input));
        } else {
          this.selectedFormat = format || "";
        }
      },
    },
  },
  components: {
    FormatRadioButtons,
  },
};
</script>

<style lang="less">
#synonymFormatSelector {
  background: #f1f1f1;

  .format-content {
    padding: 6px 20px;
    height: 200px;
    overflow: auto;
    // margin: 10px 0;
  }

  .preview-variable-cell {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .custom-control.custom-radio:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  .var-header {
    color: #8f979c;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    user-select: none;
    padding: 12px 20px 6px;
  }

  .var-text {
    color: #3d464a;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    user-select: none;
  }
  .var-desc {
    padding: 6px 20px;
  }
}
</style>
